import React, { Component } from "react";
import {Link} from "react-router-dom";

import gallery1Img from "../../../assets/images/gallary/HandlingEquipments/hoisting-capacity-of-bucket-elevators.jpg"
import gallery2Img from "../../../assets/images/gallary/HandlingEquipments/Becherwerke.jpg"
import gallery3Img from "../../../assets/images/gallary/HandlingEquipments/gallery-item3-17.jpg"
import gallery4Img from "../../../assets/images/gallary/HandlingEquipments/Roller conveyor chain drive.jpg"
import gallery5Img from "../../../assets/images/gallary/HandlingEquipments/Roller Conveyor.jpg"
import gallery6Img from "../../../assets/images/gallary/HandlingEquipments/Roller Conveyors.jpg"
import gallery7Img from "../../../assets/images/gallary/HandlingEquipments/Screw Conveyor1.jpg"
import gallery8Img from "../../../assets/images/gallary/HandlingEquipments/screw-conveyor.jpg"
import gallery9Img from "../../../assets/images/gallary/HandlingEquipments/ScrewFreights.jpg"
import gallery10Img from "../../../assets/images/gallary/HandlingEquipments/sebastian-herrmann-Vk8NI43e3HM-unsplash.jpg"

import { SRLWrapper } from "simple-react-lightbox";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Product2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:new Date(),
        };
    }
    changeDatepickerHandeller=(date)=>{
        this.setState({ startDate: date });
    }

    componentDidMount(){
        this.scrollTop();
    }

    scrollTop()
    {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
  render() {
        const startDate =this.state.startDate;

    return (
        <>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Handling Equipment</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Handling Equipment</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            <div className="package-details-wrapper pt-20">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="package-details">

                                <div className="package-tab">



                                    <div className="tab-content p-tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                            <div className="tab-contant-3">
                                                <SRLWrapper>
                                                <div className="row">

                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                      <h4>Handling Equipment</h4>
                                                             <Link to={gallery1Img} >
                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery1Img} alt="Hoisting Capacity of Bucket Elevators" />
                                                                </Link>

                                                                <Link to={gallery2Img} >
                                                                       <img width="150" height="150" style={{marginRight:10, marginTop:10}}  src={gallery2Img} alt="Becherwerke" />
                                                                   </Link>

                                                                   <Link to={gallery3Img} >
                                                                          <img width="150" height="150" style={{marginRight:10, marginTop:10}}src={gallery3Img} alt="Gallery Item3-17" />
                                                                      </Link>



                                                                                     <Link to={gallery9Img} >
                                                                                            <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery9Img} alt="Screw Freights" />
                                                                                        </Link>

                                                                                        <Link to={gallery10Img} >
                                                                                               <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery10Img} alt="Sebastian Herrmann Vk8NI43e3HM Unsplash" />
                                                                                           </Link>


                                                                                                                                               </div>

                                                                                                                                                 <div className="col-lg-12 col-md-12 col-sm-12">
                                                                                                                                                    <h4 style={{marginTop:50}}>Conveyor System</h4>

                                                                                                                                                    <Link to={gallery4Img} >
                                                                                                                                                           <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery4Img} alt="Roller Conveyor Chain Drive" />
                                                                                                                                                       </Link>

                                                                                                                                                       <Link to={gallery5Img} >
                                                                                                                                                              <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery5Img} alt="Roller Conveyor" />
                                                                                                                                                          </Link>

                                                                                                                                                          <Link to={gallery6Img} >
                                                                                                                                                                 <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery6Img} alt="Roller Conveyors" />
                                                                                                                                                             </Link>

                                                                                                                                                             <Link to={gallery7Img} >
                                                                                                                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery7Img} alt="Screw Conveyor" />
                                                                                                                                                                </Link>

                                                                                                                                                                <Link to={gallery8Img} >
                                                                                                                                                                       <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery8Img} alt="Screw Conveyor" />
                                                                                                                                                                   </Link>
                                                                                                                                                 </div>

                                                                                                                                           </div>
                                                                                                                                           </SRLWrapper><br/>
                                                                                                                                       </div>
                                                                                                                                   </div>
                                                                                                                               </div>
                                                                                                                           </div>
                                                                                                                       </div>
                                                                                                                   </div>

                                                                                                               </div>
                                                                                                           </div>
                                                                                                       </div>
                                                                                                   </>
                                                                                               );
                                                                                             }
                                                                                           }

   export default Product2;
